import { Capacitor } from '@capacitor/core';

const STORAGE_KEY = 'skipdq_customer_location';

function validLocation(value) {
  if (!value) return null;
  const lat = Number(value.lat);
  const lng = Number(value.lng);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;
  return { lat, lng };
}

export function loadCustomerLocation() {
  try {
    return validLocation(JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null'));
  } catch {
    return null;
  }
}

export function saveCustomerLocation(coords) {
  const valid = validLocation(coords);
  try {
    if (valid) sessionStorage.setItem(STORAGE_KEY, JSON.stringify(valid));
    else sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Sorting still works for this render if storage is unavailable.
  }
  return valid;
}

export async function requestCustomerLocation() {
  if (Capacitor.isNativePlatform()) {
    const { Geolocation } = await import('@capacitor/geolocation');
    const permission = await Geolocation.requestPermissions({ permissions: ['location'] });
    if (permission.location !== 'granted' && permission.coarseLocation !== 'granted') {
      const error = new Error('Location permission denied');
      error.code = 'denied';
      throw error;
    }
    const position = await Geolocation.getCurrentPosition({
      enableHighAccuracy: false,
      timeout: 10000,
      maximumAge: 60000,
    });
    return saveCustomerLocation({
      lat: position.coords.latitude,
      lng: position.coords.longitude,
    });
  }

  if (!navigator.geolocation) {
    const error = new Error('Location is not available on this device');
    error.code = 'unavailable';
    throw error;
  }

  const position = await new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject, {
      enableHighAccuracy: false,
      timeout: 10000,
      maximumAge: 60000,
    });
  });
  return saveCustomerLocation({
    lat: position.coords.latitude,
    lng: position.coords.longitude,
  });
}
